angular.module('zc.projects')

.directive 'campaignTableRow', ($state, $translate, Project, Campaign, CampaignStats, ClearanceItemSet, Devise, currencies) ->
  restrict: 'A'
  require: ['?campaign', '?filters']
  scope:
    project: '='
    campaign: '='
    filters: '='
    showActions: '='
    showStats: '='
    showCampaignDetail: '='
    showControlPercent: '='
    showClearanceSettings: '='
    showHiddenAb: '='
    hasHiddenAb: '='
    isAb: '='
    onUpdate: '&'
    canShowInvoiceAmount: '='
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_table_row.html'

  link: (scope, element, attrs) ->
    scope.Project = Project
    scope.Devise = Devise
    scope.currency = currencies[scope.project.currency]
    scope.previewUrl = Campaign.previewUrl(scope.campaign.project_base_url, scope.campaign)

    scope.canShow = scope.campaign.current_status not in ['incomplete', 'preview', 'pending']
    scope.canEdit = scope.campaign.current_status in ['incomplete', 'preview', 'pending']
    scope.canDestroy = scope.campaign.status in ['incomplete', 'preview']
    scope.adminUrl = Campaign.adminUrl(scope.project.id, scope.campaign)
    scope.canAddIncentive = Devise.isMaster() and Campaign.canAddIncentive(scope.campaign)

    scope.isV1 = scope.campaign.api_version == 1

    if scope.campaign.clearance_item_set_id
      ClearanceItemSet.find({
        projectId: scope.campaign.project_id
        id: scope.campaign.clearance_item_set_id
      })
      .then (res) ->
        scope.clearanceItemSet = res

    scope.isMaster = Devise.isMaster()
    scope.showEnabledIw = scope.campaign.iw_current_status is 'enable'
    scope.isNoControlGroupCampaign = scope.campaign.campaign_control_percent == 0 or scope.campaign.is_secret_ab

    scope.canToggleActive = _.includes(['active', 'blocked'], scope.campaign.current_status)
    scope.canFinish = !scope.showEnabledIw && _.includes(['active', 'pending', 'blocked'], scope.campaign.current_status)

    # master-only actions
    isMasterAndWidgetDisabled = scope.isMaster && !scope.showEnabledIw
    scope.canGoPreview = isMasterAndWidgetDisabled && scope.campaign.current_status == 'pending'
    scope.canGoIncomplete = isMasterAndWidgetDisabled && scope.campaign.current_status == 'preview'
    scope.canDestroy = isMasterAndWidgetDisabled && _.includes(['incomplete', 'preview'], scope.campaign.current_status)
    if scope.campaign.was_activated_before
      scope.destroyConfirmMessage = $translate.instant('projectsCampaigns.directives.campaignTableRow.confirmDeleteStartedCampaign')
    else
      scope.destroyConfirmMessage = $translate.instant('projectsCampaigns.directives.campaignTableRow.confirmDeleteCampaign')

    scope.chisq_test = true
    scope.$watch 'campaign.stats', (stats) ->
      return unless stats
      scope.chisq_test = CampaignStats.chisqTest scope.campaign.stats
    , true

    scope.githubUrl = ''
    scope.fetchGithubUrl = ->
      return Promise.resolve() if scope.githubUrl != ''

      Campaign
        .githubUrl(
          projectId: scope.campaign.project_id,
          campaignId: scope.campaign.id,
        )
        .then (githubUrl) ->
          scope.githubUrl = githubUrl

    scope.copy = ->
      Campaign.copy
        projectId: scope.campaign.project_id
        campaignId: scope.campaign.id
      .then scope.onUpdate

    scope.destroy = ->
      Campaign.destroy
        projectId: scope.campaign.project_id
        campaignId: scope.campaign.id
      .then scope.onUpdate

    scope.finish = ->
      Campaign.finish
        projectId: scope.campaign.project_id
        campaignId: scope.campaign.id
      .then scope.onUpdate

    scope.goToShow = ->
      $state.go 'admin.projects.campaigns.show.stats',
        campaignId: scope.campaign.id

    scope.goToEdit = (step)->
      if scope.isV1
        state = 'admin.projects.campaigns.edit'
        state += ".#{step}" if step
        $state.go state,
          campaignId: scope.campaign.id

    scope.goToConfirm = ->
      $state.go 'admin.projects.campaigns.confirm',
        campaignId: scope.campaign.id

    scope.goPreview = ->
      Campaign.preview
        projectId: scope.campaign.project_id
        campaignId: scope.campaign.id
      .then scope.onUpdate

    scope.goIncomplete = ->
      Campaign.incomplete
        projectId: scope.campaign.project_id
        campaignId: scope.campaign.id
      .then scope.onUpdate

    scope.toggleActive = ->
      Campaign.toggleActive
        projectId: scope.campaign.project_id
        campaignId: scope.campaign.id
        state: scope.campaign.status == 'blocked'
      .then scope.onUpdate

    scope.getCSV = ->
      Campaign.getCSV({
        csvType: 'conversions',
        apikey: scope.campaign.apikey,
        campaignId: scope.campaign.id,
        isSecretAb: scope.campaign.is_secret_ab,
        filters: scope.filters,
        fractionSize: scope.currency.fractionSize,
      })


    scope.getFileName = ->
      start_at = moment(scope.filters.start_at).format('YYYYMMDD')
      end_at = moment(scope.filters.end_at).format('YYYYMMDD')
      scope.filename = "campaign_#{scope.campaign.id}_#{start_at}_#{end_at}.csv"



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_table_row.js.coffee